import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AIStrategyPage from "@/pages/service/AIStrategyPage";

export const Route = createFileRoute("/service/ai-strategy")({
  head: () => pageHead("AI Strategy & Consulting", "AI readiness assessments, strategic roadmaps, and expert guidance for successful AI transformation.", "/service/ai-strategy", false),
  component: AIStrategyPage,
});
